/**
 * Client-side barcode validation (mirrors service/utils/barcodeValidation.js).
 */
function calcCheckDigit(dataDigits) {
    let sum = 0;
    for (let i = 0; i < dataDigits.length; i++) {
        const digit = parseInt(dataDigits[i], 10);
        if (Number.isNaN(digit)) return null;
        sum += i % 2 === 0 ? digit : digit * 3;
    }
    return (10 - (sum % 10)) % 10;
}

function detectFormat(digits) {
    if (digits.length === 13) return 'EAN-13';
    if (digits.length === 12) return 'UPC-A';
    if (digits.length === 8) return 'EAN-8';
    return 'unknown';
}

export function validateBarcode(code) {
    const raw = String(code || '').trim();
    const warnings = [];

    if (!raw) {
        return { valid: false, format: null, normalized: raw, checkDigitOk: false, warnings: ['Código vacío'] };
    }

    const digitsOnly = raw.replace(/\D/g, '');
    if (digitsOnly.length !== raw.length) {
        warnings.push('Contiene caracteres no numéricos');
    }

    const format = detectFormat(digitsOnly);
    if (!['EAN-13', 'EAN-8', 'UPC-A'].includes(format)) {
        warnings.push('Formato no reconocido');
        return { valid: false, format, normalized: digitsOnly, checkDigitOk: false, warnings };
    }

    let dataLen = format === 'EAN-8' ? 7 : format === 'UPC-A' ? 11 : 12;
    const dataDigits = digitsOnly.slice(0, dataLen);
    const checkDigit = parseInt(digitsOnly[dataLen], 10);
    const expected = calcCheckDigit(dataDigits);
    const checkDigitOk = expected === checkDigit;

    if (!checkDigitOk) warnings.push('Dígito verificador incorrecto');

    return {
        valid: checkDigitOk,
        format,
        normalized: digitsOnly,
        checkDigitOk,
        warnings,
    };
}

export function getAuditImageUrl(imageRef) {
    if (!imageRef) return null;
    if (typeof imageRef === 'string') {
        if (imageRef.startsWith('http://') || imageRef.startsWith('https://') || imageRef.startsWith('data:image')) {
            return imageRef;
        }
        const cleaned = imageRef.replace(/^data:image\/[^;]+;base64,/, '');
        if (cleaned.length > 32) {
            return `data:image/jpeg;base64,${cleaned}`;
        }
        return null;
    }
    if (imageRef?.url) return getAuditImageUrl(imageRef.url);
    if (imageRef?.base64) return getAuditImageUrl(imageRef.base64);
    return null;
}
